import { useTheme } from '@emotion/react';
import {
  Box,
  Collapse,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import GaugeChart from 'react-gauge-chart';
import { useNavigate } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCookiesLogin } from '../../config/cookies';
import { tokens } from '../../theme';
import { ScoreDescription } from '../SerasaScorePj';
import FinancialPendenciesTable from '../FinancialPendenciesTable';

const regexCEP = /^(\d{5})(\d{3})$/;
const regexCPF = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;
const regexCNPJ = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;
const regexPhone = /^(\d{2})(\d{1})?(\d{4})(\d{4})$/;

const HandlerSerasaSocoreCPF = ({ dataAPI }) => {
  // const [basicInfo, setBasicInfo] = useState({})
  // const [serasaAgro, setSerasaAgro] = useState({})
  // const [serasa, setSerasa] = useState({})

  const [partnerParticipation, setPartnerParticipation] = useState();
  const [partnersAndShareholders, setPartnersAndShareholders] = useState();

  const { cookies } = useCookiesLogin();
  const { id, last_company: bussines_id } = cookies.AUTH_TOKEN;

  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const navigateToDashboard = () => navigate("/app/dashboard");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  let basicInfo = dataAPI?.consult?.items?.find((item) => item.code === 'BASIC_INFO');

  let serasaScore = dataAPI?.consult?.items?.find((item) => item.code === 'AGRO_SCORE_CPF');

  let serasa = dataAPI?.consult?.items?.find((item) => item.code === 'SERASA');

  console.log(basicInfo);

  console.log(serasaScore, 'SERASA');
  return (
    <>
      {dataAPI && (
        <>
          <ToastContainer />
          <div
            style={{
              marginTop: 50,
            }}
          >
            {/* BASIC_INFO Section */}
            <Typography variant="h3" color={colors.grey[500]} gutterBottom>
              Informações Básicas
            </Typography>
            <Grid container spacing={4} marginBottom={3}>
              <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
                <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
                  Nome Oficial
                </Typography>
                <Typography fontSize={22}>
                  {basicInfo?.data?.results?.[0]?.basicData?.name || 'Dados Privados'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
                <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
                  CPF/CNPJ
                </Typography>
                <Typography fontSize={22}>
                  {basicInfo?.data?.results?.[0]?.basicData?.taxIdNumber === ''
                    ? 'Dados Privados'
                    : basicInfo?.data?.results?.[0]?.basicData?.taxIdNumber.replace(
                        regexCPF,
                        '$1.$2.$3-$4'
                      )}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
                <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
                  Situação Cadastral
                </Typography>
                <Typography fontSize={22}>
                  {basicInfo?.data?.results?.[0]?.basicData?.taxIdStatus || 'Dados Privados'}
                </Typography>
              </Grid>
            </Grid>
            {/* Endereços */}
            {basicInfo?.data?.results?.[0]?.addresses?.length > 0 && (
              <Typography variant="h4" color={colors.grey[500]} marginTop={3}>
                Endereços
              </Typography>
            )}
            {basicInfo?.data?.results?.[0]?.addresses?.length > 0 && (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontSize: 16 }}>Tipo</TableCell>
                      <TableCell sx={{ fontSize: 16 }}>Logradouro</TableCell>
                      <TableCell sx={{ fontSize: 16 }}>Número</TableCell>
                      <TableCell sx={{ fontSize: 16 }}>Cidade</TableCell>
                      <TableCell sx={{ fontSize: 16 }}>UF</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {basicInfo?.data?.results?.[0]?.addresses.map((address, index) => (
                      <TableRow key={index}>
                        <TableCell>{address.type || 'N/A'}</TableCell>
                        <TableCell>{address.addressMain || 'N/A'}</TableCell>
                        <TableCell>{address.number || 'S/N'}</TableCell>
                        <TableCell>{address.city || 'N/A'}</TableCell>
                        <TableCell>{address.uf || 'N/A'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>

          {/* AGRO_SCORE_CNPJ Section */}
          <div
            style={{
              marginTop: 30,
            }}
          >
            <Typography variant="h3" color={colors.grey[500]} gutterBottom>
              Informações para análise de crédito
            </Typography>
            <Grid container spacing={4} marginBottom={3} marginTop={3}>
              <Grid item xs={4} sx={{ marginY: 3 }}>
                <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
                  Agro Score
                </Typography>
                <Typography
                  color={
                    serasaScore?.data?.results?.[0]?.score < 301
                      ? '#ff5050'
                      : serasaScore?.data?.results?.[0]?.score < 701
                        ? '#ed6c02'
                        : 'secondary'
                  }
                  fontSize={22}
                >
                  {serasaScore?.data?.results?.[0]?.score} de 1000
                </Typography>
                <GaugeChart
                  id="gauge-chart2"
                  nrOfLevels={20}
                  percent={serasaScore?.data?.results?.[0]?.score / 1000}
                  textColor={colors.grey[700]}
                  arcWidth={0.2}
                  colors={['#FF0000', '#00FF00']}
                  formatTextValue={(value) => serasaScore?.data?.results?.[0]?.score}
                  style={{
                    fontWeight: 600,
                  }}
                />
              </Grid>
              <Grid item xs={4} sx={{ marginY: 3 }}>
                <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
                  Porcentagem de Risco
                </Typography>
                <Typography fontSize={22}>
                  {parseFloat(serasaScore?.data?.results?.[0]?.event_probability * 100).toFixed(2)}{' '}
                  %
                </Typography>
              </Grid>
            </Grid>
            <ScoreDescription />
          </div>

          {/* SERASA Section */}
          {serasa ? <InformacoesSerasa serasaData={serasa}></InformacoesSerasa> : <></>}

          {/* */}
          {/* <PartnerParticipationTable partnerParticipationData={serasa?.data?.results?.[0]?.partnerParticipation} /> */}

          {/* */}
          {/* <PartnersAndShareholdersTable partnersAndShareholdersData={serasa?.data?.results?.[0]?.partnersAndShareholders} /> */}
        </>
      )}
    </>
  );
};

const PartnerParticipationTable = ({ partnerParticipationData }) => {};

const PartnersAndShareholdersTable = ({ partnersAndShareholdersData }) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  return (
    <div
      style={{
        marginTop: 30,
      }}
    >
      {partnersAndShareholdersData.length > 0 ? (
        <>
          <Typography variant="h3" gutterBottom>
            Sócios e Acionistas
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nome</TableCell>
                  <TableCell>CNPJ/CPF</TableCell>
                  <TableCell>Tipo de Pessoa</TableCell>
                  <TableCell>Capital Total</TableCell>
                  <TableCell>Restrição</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {partnersAndShareholdersData.map((entry, index) => (
                  <React.Fragment key={index}>
                    <TableRow
                      onClick={() => toggleRow(index)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: expandedRow === index ? '#f9f9f9' : 'inherit',
                      }}
                    >
                      <TableCell>{entry.name}</TableCell>
                      <TableCell>{entry.cnpjCpf}</TableCell>
                      <TableCell>{entry.personType}</TableCell>
                      <TableCell>{entry.capital}</TableCell>
                      <TableCell>{entry.restriction}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={5} style={{ padding: 0 }}>
                        <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                          <Box margin={2}>
                            <Typography variant="body1" gutterBottom>
                              Detalhes do Registro
                            </Typography>
                            <ul>
                              <li>
                                <strong>Tipo do Registro:</strong> {entry.typeReg}
                              </li>
                              <li>
                                <strong>Subtipo do Registro:</strong> {entry.subtype}
                              </li>
                              <li>
                                <strong>Situação do Capital Total:</strong> {entry.companySituation}
                              </li>
                              <li>
                                <strong>Código Socio Consistido:</strong> {entry.situation}
                              </li>
                              <li>
                                <strong>Filler:</strong> {entry.filler}
                              </li>
                            </ul>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : null}
    </div>
  );
};

export const InformacoesSerasa = ({ serasaData }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [expandedRow, setExpandedRow] = useState(null);

  const dataEntries = Object.entries(serasaData?.data?.results?.[0]?.data).map(
    ([type, details]) => ({
      type,
      ocorrencias: details?.occurrences,
      quantidade: details?.valueOfOccurrences || '0.00',
      details: details,
    })
  );

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  // Função para traduzir os nomes dos campos
  function translaterKeys(key) {
    switch (key) {
      case 'finalDate':
        return 'Data Final';
      case 'value':
        return 'Valor';
      case 'totalQuantity':
        return 'Quantidade Total';
      case 'protest':
        return 'Protesto';
      case 'convem':
        return 'Convênios';
      case 'judicialAction':
        return 'Ações Judiciais';
      case 'financialRestrictions':
        return 'Restrições Financeiras';
      case 'bankruptcies':
        return 'Falências';
      case 'acheiRecheque':
        return 'Achados de Cheque';
      case 'ccf':
        return 'Cheques sem Fundo';
      case 'financialPendencies':
        return 'Pendências Financeiras';
      case 'documentsAlert':
        return 'Alertas de Documentos';
      case 'subJudice':
        return 'Sub Judice';
      case 'letterDate':
        return 'Data da Carta';
      case 'notaryNumber':
        return 'Número de Cartório';
      default:
        return key;
    }
  }


  return (
    <div style={{ marginTop: 30 }}>
      <Typography variant="h3" color={colors.grey[500]} gutterBottom>
        Informações de Crédito
      </Typography>
      <TableContainer component={Paper} elevation={3} style={{ borderRadius: 10 }}>
        <Table>
          <TableHead
            style={{
              backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : '#83d84d',
            }}
          >
            <TableRow>
              <TableCell
                style={{
                  color: theme.palette.mode === 'dark' ? '#e0e0e0' : '#141414',
                  fontWeight: 'bold',
                  fontSize: 18,
                }}
              >
                Tipo
              </TableCell>
              <TableCell
                style={{
                  color: theme.palette.mode === 'dark' ? '#e0e0e0' : '#141414',
                  fontWeight: 'bold',
                  fontSize: 18,
                }}
              >
                Quantidade
              </TableCell>
              <TableCell
                style={{
                  color: theme.palette.mode === 'dark' ? '#e0e0e0' : '#141414',
                  fontWeight: 'bold',
                  fontSize: 18,
                }}
              >
                Valor total
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataEntries.slice(0, -3).map((entry, index) => (
              <React.Fragment key={index}>
                <TableRow
                  onClick={() => toggleRow(index)}
                  style={{
                    cursor: entry.ocorrencias > 0 ? 'pointer' : 'default',
                    backgroundColor: expandedRow === index ? colors.greenAccent[600] : 'inherit',
                    transition: 'background-color 0.3s ease',
                  }}
                >
                  <TableCell style={{ fontSize: 16 }}>{translaterKeys(entry?.type)}</TableCell>
                  <TableCell style={{ fontSize: 16 }}>{entry?.ocorrencias}</TableCell>
                  <TableCell
                    style={{ fontSize: 16 }}
                  >{`R$ ${parseFloat(entry?.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</TableCell>
                </TableRow>
                {entry.ocorrencias > 0 && (
                  <TableRow>
                    <TableCell colSpan={3} style={{ padding: 0 }}>
                      <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                        <Box
                          margin={2}
                          sx={{
                            backgroundColor: colors.primary[500],
                            borderRadius: 2,
                            padding: 2,
                          }}
                        >
                          <Typography variant="h4" gutterBottom color={colors.greenAccent[400]}>
                            Detalhes de {translaterKeys(entry?.type)}:
                          </Typography>

                          <FinancialPendenciesTable
                            details={
                              entry.details[`${entry.type}Details`] ||
                              entry.details[`${entry.type}sDetails`] ||
                              []
                            }
                          />
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default HandlerSerasaSocoreCPF;
